import { v4 as uuidv4 } from 'uuid';

import elemento_tipo_model from '@/shared/models/elemento_tipo_model';
import forma_model from '@/shared/models/forma_model';
import material_prima_familia_model from '@/shared/models/materia_prima_familia_model';
import suaje_model from '@/shared/models/suaje_model';
import request_elemento_proceso_model from './request_elemento_proceso_model';

export default {
  AnchoTotal: 0,
  AltoTotal: 0,
  AnchoMaterial: 0,
  Base: 0,
  CantidadCambios: 0,
  CantidadColoresAdhesivo: 0,
  CantidadColoresFrente: 0,
  CantidadColoresLiner: 0,
  Codigo: null,
  CodigoElementoTipo: null,
  CodigoForma: 1,
  CodigoMateriaPrimaFamilia: null,
  CodigoSolicitud: null,
  CodigoSuaje: null,
  CodigoAdaptador: null,
  DensidadResultante: null,
  Desarrollo: 0,
  ElementoTipo: { ...elemento_tipo_model },
  Engranaje: 0,
  EtiquetasDesarrollo: 0,
  EtiquetasEje: 0,
  Forma: { ...forma_model },
  GapDesarrollo: 0,
  GapEje: 0,
  ItemElemento: 1,
  AnchoMinimoMaterial: 0,
  LargoMinimoMaterial: 0,
  MateriaPrimaFamilia: { ...material_prima_familia_model },
  MedidaDesarrollo: 0,
  MedidaEje: 0,
  Paginas: null,
  RotacionImposicion: null,
  Sellado: 0,
  Solapa: 0,
  SolicitudElementoProceso: [{ ...request_elemento_proceso_model, id: uuidv4() }],
  // SolicitudElementoTinta: [],
  Suaje: { ...suaje_model },
  Adaptador: null,
  UnidadMedida: 'mm',
};
